import useAuth from './useAuth';
import useTheme from './useTheme';

export default function useDistributionLogo() {
  const { distribution } = useAuth();

  const theme = useTheme();

  const isDarkMode = theme === 'DARK';

  if (!distribution?.logos) return undefined;

  const darkModeLogo =
    distribution.logos.logo_fe_1024 ??
    distribution.logos.logo_fe_512 ??
    distribution.logos.logo_fe_256 ??
    distribution.logos.logo_fe_128 ??
    distribution.logos.logo_fe;

  const lightModeLogo =
    distribution.logos.logo_1024 ??
    distribution.logos.logo_512 ??
    distribution.logos.logo_256 ??
    distribution.logos.logo_128 ??
    distribution.logos.logo;

  if (isDarkMode) return darkModeLogo ?? lightModeLogo;

  return lightModeLogo ?? darkModeLogo;
}
